<template>
	<div class="dc-wrap-content">
		<div class="sd-divider"></div>
		<div class="sd-content-section">
			<a id="dataEncryption"></a>
			<h3 v-html="translations.dcDataSecurityTitle"></h3>
			<div class="sd-wrap-box">
				<div class="sd-content-full">
					<p v-html="translations.dcDataSecurityContent1"></p>
					<p v-html="translations.dcDataSecurityContent2"></p>
					<ul>
						<li v-html="translations.dcDataSecurityContent3"></li>
						<li v-html="translations.dcDataSecurityContent4"></li>
						<li v-html="translations.dcDataSecurityContent5"></li>
					</ul>
					<p v-html="translations.dcDataSecurityContent6"></p>
				</div>
			</div>
		</div>
		<div class="sd-content-section">
			<a id="operation"></a>
			<h3 v-html="translations.dcOperationTitle"></h3>
			<div class="sd-wrap-box">
				<div class="sd-content-full">
					<p v-html="translations.dcOperationContent1"></p>
					<p v-html="translations.dcOperationContent2"></p>
				</div>
			</div>
		</div>
		<div class="sd-content-section">
			<a id="dataManagement"></a>
			<h3 v-html="translations.dcDataManagementTitle"></h3>
			<div class="sd-wrap-box">
				<div class="sd-content-full">
					<p v-html="translations.dcDataManagementContent"></p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import i18n from '@/translations/i18n';
export default {
	name: 'DatabaseContent',
	data() {
		return {
			translations: {},
		};
	},
	computed: {
		computedTranslations: function() {
			return {
				dcDataSecurityTitle: this.$t('dcDataSecurityTitle'),
				dcDataSecurityContent1: this.$t('dcDataSecurityContent1'),
				dcDataSecurityContent2: this.$t('dcDataSecurityContent2'),
				dcDataSecurityContent3: this.$t('dcDataSecurityContent3'),
				dcDataSecurityContent4: this.$t('dcDataSecurityContent4'),
				dcDataSecurityContent5: this.$t('dcDataSecurityContent5'),
				dcDataSecurityContent6: this.$t('dcDataSecurityContent6'),
				dcOperationTitle: this.$t('dcOperationTitle'),
				dcOperationContent1: this.$t('dcOperationContent1'),
				dcOperationContent2: this.$t('dcOperationContent2'),
				dcDataManagementTitle: this.$t('dcDataManagementTitle'),
				dcDataManagementContent: this.$t('dcDataManagementContent'),
			};
		},
	},
	created() {
		this.translations = this.computedTranslations;
		this.hyphenateText();
		window.addEventListener('languageChange', this.languageEvent);
	},
	beforeDestroy() {
		window.removeEventListener('languageChange', this.languageEvent);
	},
	methods: {
		languageEvent() {
			if (i18n.locale !== 'en') this.hyphenateText();
			else this.translations = this.computedTranslations;
		},
		hyphenateText() {
			let that = this;
			this.$global.getHyphenation(this.computedTranslations, function(data) {
				that.translations = data;
			});
		},
	},
};
</script>

<style scoped>
.dc-wrap-content {
	width: 100%;
	margin: auto;
}
</style>
